module.exports = __webpack_public_path__ + "static/media/cat-flag.54ed9ef1.png";